<template lang="pug">

  div
    v-layout(align-center justify-space-between)
      div
        span(class="title") Snags
        span(class="ml-3 grey--text subheading") Site
        span(class="ml-3 grey--text subheading") Date
        span(class="ml-3 grey--text subheading") Comment
        span(class="ml-3 grey--text subheading") Percentage
      v-btn(
        :disabled="loading || error"
        class="ma-0"
        icon
        @click="download")
        v-icon cloud_download
    v-progress-linear(
      v-if="loading"
      class="ma-0"
      color="grey"
      height="1"
      indeterminate)
    v-divider(v-else)

    a(ref="anchor")

</template>

<script>
import Papa from "papaparse";
import moment from "moment";

export default {
  name: "jobs",
  data () {
    return {
      dialog: false,
      error: false,
      loading: false,
      report: []
    };
  },
  created () {
    this.loading = true;
    this.$http.
      get("/api/reports/snags").
      then(({ data }) => this.report = data).
      catch(() => this.error = true).
      finally(() => this.loading = false);
  },
  methods: {
    download () {
      const report = this.report.
        map((row) => ({
          Site: row.site,
          Percentage: row.percentage ? row.percentage.toFixed(0) : null,
          Comment: row.comment ? row.comment.replace(";", ",") : null,
          Date: row.date ? new Date(row.date).toLocaleDateString() : null
        }));
      const csv = Papa.unparse(report);
      // Add a byte order mark (BOM: U+FEFF)
      const blob = new Blob(["\ufeff", csv]);
      var a = this.$refs.anchor;
      a.href = window.URL.createObjectURL(blob);
      a.download = `snags_${moment().format("YYYYMMDD")}.csv`;
      a.click();
      this.dialog = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Reports/Snags.vue